import React, { type ChangeEvent } from 'react';
import SettingBlock from './SettingBlock';
import RoSColorPicker from './RoSColorPicker';
import FontPicker, { type SAFonts } from '@atoms/FontPicker';
import { useRoSContext } from '@components/Presentation/context/RoSContext';

interface SlideHeadingProps {
  color: string;
  updateColor: (color: string | boolean) => void;
}
export default function SlideHeading({ color, updateColor }: SlideHeadingProps) {
  const { selectedSlide } = useRoSContext();

  return (
    <SettingBlock
      title="Heading"
      addPadding
    >
      <RoSColorPicker
        color={color || '#FFFFFF'}
        onChange={updateColor}
        disableGradient
      >
        Heading color
      </RoSColorPicker>
      <div className='flex justify-between items-center'>
        <span className='text-sm'>Heading font</span>
        <FontPicker
          selectedFont={selectedSlide.setting.HeadingFont as SAFonts || 'Sans-Serif'}
          onSelectFont={(font: SAFonts) => selectedSlide.handler.updateSetting('HeadingFont', font)}
        />
      </div>
    </SettingBlock>
  );
}
